import {ACTION} from './constant';

let initialState = {
    glossaryData:{},
    glossaryAlphabet:{},
};

export default function GlossaryReducer(state=initialState, action) {
    switch (action.type) {
        case ACTION.GET_GLOSSARY_DATA : 
            return {...state, glossaryData:{...action.data}};
        case ACTION.GET_GLOSSARY_ALPHABET : 
            return {...state, glossaryAlphabet:{...action.data}};
        default:
            return state;    
    }
};